import loggingService from '../util/loggingService'

var serviceName = 'artifactService'
var path = '/Lookup/Artifact/'
var isDebug = false

function listArtifact (http) {
    loggingService.log(isDebug, serviceName, 'listArtifact')

    return http.get(path + 'ListArtifact')
}

function listArtifactCategory (http) {
    loggingService.log(isDebug, serviceName, 'listArtifactCategory')

    return http.get(path + 'ListArtifactCategory')
}

export default {
    listArtifact: listArtifact,
    listArtifactCategory: listArtifactCategory
}



// WEBPACK FOOTER //
// ./src/services/lookup/artifactService.js